import React, {memo} from 'react';
import {
  ActivityIndicator,
  Dimensions,
  Platform,
  StyleSheet,
  Pressable,
  View,
} from 'react-native';
import Animated from 'react-native-reanimated';
import {MoblicoPromotionType} from 'src/types/Promotions';
import {ensureHttps} from 'src/services/StringUtils';
import {handleClick} from './MoblicoPromotionClickHandler';
import Styles from 'src/components/Styles';

const width = Dimensions.get('window').width;
const promotionHeightRatio = 255 / 306;

type Props = {
  item: MoblicoPromotionType;
  index: number;
  isLoading: boolean;
  onLoad: () => void;
};

const PromotionItem = ({item, index, isLoading, onLoad}: Props) => {
  const promotionImage = ensureHttps(item.image.url);
  const widthImage = width - 40;
  return (
    <Pressable
      onPress={() => handleClick(item)}
      style={{
        width: widthImage,
        height: widthImage * promotionHeightRatio,
        left: 18,
      }}
      testID={`Promotion${item.name}`}
      nativeID={`Promotion${item.name}`}
      accessibilityLabel={`Promotion${item.name}`}
      aria-label={`Promotion${item.name}`}
    >
      <Animated.Image
        source={{uri: promotionImage}}
        style={styles.imageContainer}
        onLoad={onLoad}
        accessibilityRole="image"
        accessibilityLabel={`${item?.caption}`}
      />
      {isLoading && (
        <View style={styles.spinnerOverlay}>
          <ActivityIndicator size="large" color="white" />
        </View>
      )}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  imageContainer: {
    flex: 1,
    marginBottom: Platform.select({ios: 0, android: 1}),
    borderRadius: Styles.Spacing.m2,
    borderColor: '#C2C2C5',
    shadowColor: '#000',
    shadowOffset: {width: 1, height: 1},
    elevation: 5,
    alignItems: 'center',
    shadowRadius: 2,
    shadowOpacity: 0.4
  },
  spinnerOverlay: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
    flex: 1,
    alignSelf: 'center',
  },
});

export default memo(PromotionItem);
